<template>
  <f7-page class="main-recuperarMercanciaVolcada">
    <!-- <UCCodeScanner :fab-button-show="true" /> -->
    <f7-navbar
      :style="appTheme"
      sliding
    >
      <f7-nav-left name="frmRecuperarMercanciaVolcada-nav-lefth">
        <f7-link @click="NavigateBack()">
          <img
            alt="iconBack"
            src="@/static/icons/back.svg"
          >
        </f7-link>
      </f7-nav-left>
      <f7-nav-title> {{ $t('production.dump.retrieve.pageTitle') }} </f7-nav-title>
    </f7-navbar>
    <PCInformacionLineaPunto
      class="navbar-color navbar-amarillo-1"
      :activo="activo"
    />
    <div class="div-001">
      <!-- Buscador de elementos volcados -->
      <div class="div-componenteDeBusqueda">
        <UCProductionElement
          :restablecer="limpiarLecturaUCElementoDeProduccion"
          :mostrar-titulo="false"
          :activo="activo"
          :autofocus-on-input="lecturaCodigoBarrasPorDefecto"
          :modo-lectura-init="lecturaCodigoBarrasPorDefecto ? 'Codigo' : 'uc'"
          :trabajar-con-numeros-de-serie="Boolean(trabajarConNumerosDeSerie)"
        />
      </div>

      <div class="div-busquedaEnElementosVolcados">
        <f7-row>
          <f7-col
            v-if="!(filtroPartida != null || filtroUnidadLogisitica != null)"
            width="70"
            class="col-tituloBusqueda"
          >
            <span class="span-textoBusqueda">{{ $t('production.dump.retrieve.search.title') }} </span>
          </f7-col>
          <f7-col
            v-if="filtroPartida != null || filtroUnidadLogisitica != null"
            width="70"
            class="col-tituloFiltros"
          >
            <span class="span-textoBusqueda">
              {{ $t('production.dump.retrieve.filtersLabel') }}
            </span>
            <f7-chip
              v-if="filtroPartida != null"
              :text="filtroPartida.IdentificadorUnicoCodigoDeBarras"
              deleteable
              @click="eliminarFiltro"
            />
            <f7-chip
              v-if="filtroUnidadLogisitica != null"
              :text="filtroUnidadLogisitica.NumeroSerie"
              deleteable
              @click="eliminarFiltro"
            />
          </f7-col>
          <f7-col
            width="20"
            class="col-opcionesDeBusqueda"
          >
            <img
              v-if="filtroPartida == null && filtroUnidadLogisitica == null"
              alt="iconSearch"
              src="@/static/icons/ic_search_2.svg"
              @click="filtrarElentosCola"
            >
          </f7-col>
        </f7-row>
      </div>
      <div class="div-contenidofrmRecuperarMercanciaVolcada">
        <!-- Listado de ultimos volcados completo -->
        <PCUltimosVolcados
          ref="PCUltimosVolcados"
          :punto-de-volcado="puntoDeVolcado"
          :activo="activo"
          :filtro="filtroUltimosVolcados"
          @volcado-seleccionado="VolcadoSeleccionado"
        />
      </div>
    </div>
    <!-- Action filtro Busqueda -->
    <f7-actions
      id="actions-FiltroBusqueda"
      class="actions-busquedas"
      :opened="actionFiltroBusquedaAbierto"
      @actions:closed="actionFiltroBusquedaAbierto = false"
    >
      <div v-if="actionFiltroBusquedaAbierto">
        <div v-show="modoBusqueda === modosDeBusqueda.UNIDAD_LOGISTICA">
          <div class="div-tituloBuscador">
            <span class="span-tituloBuscador"> {{ $t('production.dump.retrieve.filterSearchActions.logisticUnit.title') }} </span>
          </div>
          <form
            class="from-busquedas"
            @submit.prevent="aplicarFiltrosElementosCola()"
          >
            <f7-row class="row-campoDeEntrada">
              <f7-col width="20">
                <div class="div-modoInput">
                  <div
                    class="div-btnModoInput"
                    @click="modoBusqueda = modosDeBusqueda.PARTIDA"
                  >
                    <img
                      class="img-btnModoInput"
                      alt="iconUnidad"
                      src="@/static/icons/ic_logistic_unit.svg"
                      width="50"
                      height="50"
                    >
                  </div>
                </div>
                <div class="div-btnInformacionCambioCirculo">
                  <img
                    class="img-btnCambioModo"
                    alt="iconExchange"
                    src="@/static/icons/ic_exchange_arrows.svg"
                    width="18"
                    height="18"
                  >
                </div>
              </f7-col>

              <f7-col width="80">
                <input
                  class="input-busquedaCodigos"
                  :label="$t('common.logisticsUnit')"
                  type="text"
                  :placeholder="$t('common.logisticsUnit')"
                  required
                  clear-button
                  :value="valorCampoBusqueda"
                  @input="valorCampoBusqueda = $event.target.value"
                >
              </f7-col>
            </f7-row>
          </form>
        </div>

        <div v-show="modoBusqueda === modosDeBusqueda.PARTIDA">
          <div class="div-tituloBuscador">
            <span class="span-tituloBuscador"> {{ $t('production.dump.retrieve.filterSearchActions.batch.title') }}  </span>
          </div>
          <form
            class="from-busquedas"
            @submit.prevent="aplicarFiltrosElementosCola()"
          >
            <f7-row class="row-campoDeEntrada">
              <f7-col width="20">
                <div class="div-modoInput">
                  <div
                    class="div-btnModoInput"
                    @click="modoBusqueda = modosDeBusqueda.NOMBRE_FAMILIA"
                  >
                    <img
                      class="img-btnModoInput"
                      alt="iconPartida"
                      src="@/static/icons/ic_batch.svg"
                      width="50"
                      height="50"
                    >
                  </div>
                </div>
                <div class="div-btnInformacionCambioCirculo">
                  <img
                    class="img-btnCambioModo"
                    alt="iconExchange"
                    src="@/static/icons/ic_exchange_arrows.svg"
                    width="18"
                    height="18"
                  >
                </div>
              </f7-col>

              <f7-col width="80">
                <input
                  class="input-busquedaCodigos"
                  :label="$t('common.batch')"
                  type="text"
                  :placeholder="$t('common.batch')"
                  required
                  clear-button
                  :value="valorCampoBusqueda"
                  @input="valorCampoBusqueda = $event.target.value"
                >
              </f7-col>
            </f7-row>
          </form>
        </div>

        <div v-show="modoBusqueda === modosDeBusqueda.NOMBRE_FAMILIA">
          <div class="div-tituloBuscador">
            <span class="span-tituloBuscador"> {{ $t('production.dump.retrieve.filterSearchActions.family.title') }} </span>
          </div>
          <form
            class="from-busquedas"
            @submit.prevent="aplicarFiltrosElementosCola()"
          >
            <f7-row class="row-campoDeEntrada">
              <f7-col width="20">
                <div class="div-modoInput">
                  <div
                    class="div-btnModoInput"
                    @click="modoBusqueda = modosDeBusqueda.UNIDAD_LOGISTICA"
                  >
                    <img
                      class="img-btnModoInput"
                      alt="iconFmilia"
                      src="@/static/icons/ic_familia.svg"
                      width="50"
                      height="50"
                    >
                  </div>
                </div>
                <div class="div-btnInformacionCambioCirculo">
                  <img
                    class="img-btnCambioModo"
                    alt="iconExchange"
                    src="@/static/icons/ic_exchange_arrows.svg"
                    width="18"
                    height="18"
                  >
                </div>
              </f7-col>
              <f7-col width="80">
                <input
                  class="input-busquedaCodigos"
                  :label="$t('common.batch')"
                  type="text"
                  :placeholder="$t('production.dump.retrieve.filterSearchActions.family.input.placeholder')"
                  required
                  clear-button
                  :value="valorCampoBusqueda"
                  @input="valorCampoBusqueda = $event.target.value"
                >
              </f7-col>
            </f7-row>
          </form>
        </div>
      </div>

      <!-- Separador -->
      <div class="div-elementoSeparador" />
      <!-- Pie de  Boton Opciones busqueda -->
      <div class="div-opcionesBusqueda">
        <f7-row>
          <f7-col
            width="50"
            class="col-cancelar"
          >
            <a
              class="link link-cancelar"
              @click="actionFiltroBusquedaAbierto = false; valorCampoBusqueda = ''"
            >
              {{ $t('common.cancel').toUpperCase() }}
            </a>
          </f7-col>
          <f7-col
            width="50"
            class="col-buscar"
          >
            <a
              class="link link-buscar"
              @click="aplicarFiltrosElementosCola()"
            >
              {{ $t('common.search').toUpperCase() }}
            </a>
          </f7-col>
        </f7-row>
      </div>
    </f7-actions>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import { Log } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import PCInformacionLineaPunto from '@/components/production/traceability/PCInformacionLineaPunto.vue';
import PCUltimosVolcados from '@/components/production/traceability/PCUltimosVolcados.vue';
import UCProductionElement from '@/components/common/UCProductionElement.vue';
import { HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmRetrieveOverturnedMerchandise',
  components: {
    PCUltimosVolcados,
    UCProductionElement,
    PCInformacionLineaPunto,
  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    puntoDeVolcado: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      lineaSeleccionada: '',
      limpiarLecturaUCElementoDeProduccion: 1, // Con incrementos limpia las lecturas realizadas.
      filtroUnidadLogisitica: null,
      filtroPartida: null,
      filtroUltimosVolcados: null, // Variable para enviar filtros al elemento PCUltimosVolcados
      fechaActualizacionUltimosVolcados: null,
      unidadLogistica: null,
      partida: '',
      actionFiltroBusquedaAbierto: false, // Controla la apertura del action que permite realizar filtros.
      modosDeBusqueda: {
        UNIDAD_LOGISTICA: 'ul',
        PARTIDA: 'p',
        NOMBRE_FAMILIA: 'nf',
      },
      modoBusqueda: '',
      valorCampoBusqueda: '',
      trabajarConNumerosDeSerie: useParamRef('trabajarConNumerosDeSerie'),
      lecturaCodigoBarrasPorDefecto: useSettingRef('Volcado.LecturaCodigoBarrasPorDefecto'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'lineaDeProduccionSeleccionada',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'partidaSeleccionada',
      'volcadoSeleccionado',
      'unidadLogisticaSeleccionada',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-orange)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  watch: {
    activo(val) {
      if (val) {
        Log(this, this.activo.name);
        this.InicializarComponente();
        this.activarListener();
      } else {
        this.desactivarListener();
        this.filtroUnidadLogisitica = null;
        this.filtroUnidadLogisitica = null;
      }
    },
  },
  mounted() {
    this.InicializarComponente();
    this.activarListener();
  },
  beforeUnmount() {
    this.desactivarListener();
    this.filtroUnidadLogisitica = null;
    this.filtroUnidadLogisitica = null;
  },
  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.lineaSeleccionada = this.lineaDeProduccionSeleccionada;
      this.ActualizarComponenteDeUltimosVolcados();
      this.modoBusqueda = this.modosDeBusqueda.UNIDAD_LOGISTICA;
    },
    NavigateBack() {
      f7.views.main.router.back();
    },
    // Método ActualizarComponenteDeUltimosVolcados
    ActualizarComponenteDeUltimosVolcados() {
      Log(this, this.ActualizarComponenteDeUltimosVolcados.name);
      this.fechaActualizacionUltimosVolcados = new Date();
      this.$refs.PCUltimosVolcados.ActualizarDatos();
    },
    activarListener() {
      Log(this, this.activarListener.name);
      eventBus.on('elementoDeProduccionEstablecido', (data) => {
        this.elementoDeProduccionEstablecido(data);
      });
      eventBus.on('movimientoRealizado', () => {
        this.ActualizarComponenteDeUltimosVolcados();
      });
    },
    desactivarListener() {
      Log(this, this.desactivarListener.name);
      eventBus.off('elementoDeProduccionEstablecido');
      eventBus.off('movimientoRealizado');
    },

    elementoDeProduccionEstablecido(data) {
      Log(this, this.elementoDeProduccionEstablecido.name);
      // Tipo de lectura unidad Logistica
      if (data.Existencias) {
        this.generarNoticacion(this.$t('production.dump.retrieve.productionElementChange.hasStockToast.text'));
      }

      this.mostrarElementosRecuperables(data.ElementoProduccion, data.Tipo);
      this.limpiarControlUCElementoDeProduccion();
    },
    /** Método generarNoticacion */
    generarNoticacion(mensaje) {
      Log(this, this.generarNoticacion.name);
      HiNotification.Toast(mensaje, 4000);
    },

    limpiarControlUCElementoDeProduccion() {
      Log(this, this.limpiarControlUCElementoDeProduccion.name);
      // NOTA: Limpia el control siempre que detecta un cambio en la variable
      this.limpiarLecturaUCElementoDeProduccion += 1;
    },

    eliminarFiltro() {
      Log(this, this.eliminarFiltro.name);
      this.filtroPartida = null;
      this.filtroUnidadLogisitica = null;
      this.filtroUltimosVolcados = null;
      this.valorCampoBusqueda = '';
    },

    mostrarElementosRecuperables(elementoProduccion, tipo) {
      Log(this, this.mostrarElementosRecuperables.name);
      this.partida = null;
      this.unidadLogistica = null;
      if (tipo === 'uc' || tipo === null) {
        this.unidadLogisticaSeleccionada = elementoProduccion;
        f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseULView');
      }
      // Tipo de lectura partida
      if (tipo === 'p') {
        this.partidaSeleccionada = elementoProduccion;
        f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseSplitView');
      }
    },

    filtrarElentosCola() {
      Log(this, this.filtrarElentosCola.name);
      this.actionFiltroBusquedaAbierto = true;
    },

    aplicarFiltrosElementosCola() {
      Log(this, this.aplicarFiltrosElementosCola.name);
      this.actionFiltroBusquedaAbierto = false;
      // Tipo de busqueda Unidad Logistica
      if (this.modoBusqueda === this.modosDeBusqueda.UNIDAD_LOGISTICA) {
        this.filtroUnidadLogisitica = {
          NumeroSerie: this.valorCampoBusqueda,
        };
        this.filtroPartida = null;
        this.filtroUltimosVolcados = [{
          CampoFiltrante: 'NumeroSerie',
          Filtro: this.valorCampoBusqueda,
        }];
        return;
      }
      // Tipo de busqueda partida
      if (this.modoBusqueda === this.modosDeBusqueda.PARTIDA) {
        this.filtroPartida = {
          IdentificadorUnicoCodigoDeBarras: this.valorCampoBusqueda,
        };
        this.filtroUnidadLogisitica = null;
        this.filtroUltimosVolcados = [{
          CampoFiltrante: 'IdentificadorUnicoCodigoDeBarras',
          Filtro: this.valorCampoBusqueda,
        }];
        return;
      }
      // Tipo de busqueda nombre Familia
      if (this.modoBusqueda === this.modosDeBusqueda.NOMBRE_FAMILIA) {
        this.filtroPartida = {
          IdentificadorUnicoCodigoDeBarras: this.valorCampoBusqueda,
        };
        this.filtroUnidadLogisitica = null;
        this.filtroUltimosVolcados = [{
          CampoFiltrante: 'FamiliaArticulo',
          Filtro: this.valorCampoBusqueda,
        }];
        return;
      }
      this.valorCampoBusqueda = '';
    },
    // Método VolcadoSeleccionado
    VolcadoSeleccionado(objVolcado) {
      Log(this, this.VolcadoSeleccionado.name);
      this.volcadoSeleccionado = objVolcado; // Establecemos la variable global.
      this.partidaSeleccionada = { Id: objVolcado.Partida.Id };
      if (objVolcado.IdUnidadLogistica !== 0) {
        this.unidadLogisticaSeleccionada = {
          Id: objVolcado.IdUnidadLogistica,
          NumeroSerie: objVolcado.NumeroSerie,
        };
      }
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseSplitView');
    },
  },
};
</script>

<style scoped>
.div-componenteDeBusqueda {
  background: var(--his-tierra-white);
  min-height: 50px;
}

.div-busquedaEnElementosVolcados {
  height: 41px;
  background: #e7e7ea;
}

.col-opcionesDeBusqueda {
  padding-right: 17px;
  text-align: right;
  margin: 8px;
}

.col-tituloBusqueda {
  padding-top: 8px;
  padding-left: 17px;
}

.col-tituloFiltros {
  padding-top: 3px;
  padding-left: 17px;
}

.span-textoBusqueda {
  color: var(--his-ash-gray);
  font-size: 15px;
  font-weight: 400;
}

a.link.link-cancelar {
  color: var(--his-tomate);
  font-size: 14px;
  font-weight: 500;
}

a.link.link-buscar {
  color: #009ba6;
  font-size: 18px;
  font-weight: 500;
}

.card-footer .link {
  color: #009ba6;
}

.col-buscar {
  text-align: right;
}

.div-elementoSeparador {
  border-top: 1px solid var(--his-silver);
  width: 90%;
  margin-left: 20px;
}

.span-tituloBuscador {
  color: var(--his-ash-gray);
  font-size: 14px;
}

/** Estilos del Buscador  con acciones **/
.input-busquedaCodigos {
  width: 89%;
  background: #fff;
  margin-right: 18px;
  margin-left: 18px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  min-height: 60px;
  margin-top: 16px;
  margin-bottom: 16px;
  color: var(--his-darkgray);
  font-size: 17px;
  padding-left: 18px;
}

.div-modoInput {
  margin-top: 16px;
  margin-bottom: 0;
}

.div-btnModoInput {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  margin-left: 15px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  height: 100%;
  width: 100%;
  min-height: 58px;
  box-shadow: 0 6px 10px #6666662b;
}

.div-btnInformacionCambioCirculo {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px solid var(--his-silver);
  background: var(--his-tierra-white);
  position: relative;
  left: 55%;
  top: -13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-opcionesBusqueda {
  padding: 17px;
}

.actions-busquedas {
  background: var(--his-tierra-white);
}

.div-tituloBuscador {
  margin-top: 15px;
  margin-left: 15px;
}

.img-btnModoInput {
  min-height: 36px;
  width: 45%;
}

.img-btnCambioModo {
  width: 15px;
}

.navbar-amarillo-1 {
  background-color: var(--his-orange) !important;
}
</style>
